module.exports = __webpack_public_path__ + "img/drives.535c454d.svg";